export const AdStatus = {
  ACTIVATED: 'activated',
  DEACTIVATED_USER: 'deactivated_user',
  DEACTIVATED_ADMIN: 'deactivated_admin',
  ARCHIVED_AUTO: 'archived_auto',
  ARCHIVED_MANUAL: 'archived_manual',
  ARCHIVED_USER: 'archived_user',
  SOLD: 'sold',
};

export const adStatusTranslations = {
  [AdStatus.ACTIVATED]: 'Aktivan',
  [AdStatus.DEACTIVATED_USER]: 'Neaktivan',
  [AdStatus.DEACTIVATED_ADMIN]: 'Neaktivan (admin)',
  [AdStatus.ARCHIVED_AUTO]: 'Arhiviran (automatski)',
  [AdStatus.ARCHIVED_MANUAL]: 'Arhiviran (admin)',
  [AdStatus.ARCHIVED_USER]: 'Arhiviran (korisnik)',
  [AdStatus.SOLD]: 'Prodat',
};
